import { SchedulerTaskProgramSync } from '../scheduler-task-program-sync';
import { parseNumber } from '../../utils/number.utils';

export class SchedulerTaskProgramSyncBuilder {
  static fromJson(json) {
    return (json)
      ? new SchedulerTaskProgramSync(
        json.synced,
        json.syncedTaskProgram,
        parseNumber(json.syncedTaskProgramStartDate),
        json.syncedTask,
        json.notScheduledTaskPrograms
      )
      : null;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/scheduler-task-program-sync.builder.ts